import { BASE_COURSE_TYPES, canonicalCourseType, collapseCourseTypeSpaces } from './courseTypes';

/** Match My Courses tile underline colours */
export const COURSE_TYPE_DOT_COLORS = {
  External: '#e6c229',
  Internal: '#d32f2f',
  Weapons: '#8e24aa',
  'Dim Mak': '#f57c00',
  Fitness: '#1976d2',
};

export const COURSE_TYPE_DEFAULT_DOT = '#9E9E9E';

const DOT_COLOR_BY_KEY = Object.fromEntries(
  Object.entries(COURSE_TYPE_DOT_COLORS).map(([label, color]) => [
    label.toLowerCase(),
    color,
  ])
);

const TYPE_SORT_INDEX = Object.fromEntries(
  BASE_COURSE_TYPES.map((label, index) => [label.toLowerCase(), index])
);

/**
 * @returns {{ color: string, borderColor?: string, borderWidth?: number }}
 */
export function getCourseTypeDotStyle(courseTypeRaw, { isDarkMode = false } = {}) {
  const canonical = canonicalCourseType(courseTypeRaw);
  if (!canonical) {
    return { color: COURSE_TYPE_DEFAULT_DOT };
  }
  const key = collapseCourseTypeSpaces(canonical).toLowerCase();
  if (key === 'shinobi') {
    return {
      color: isDarkMode ? '#f5f5f5' : '#212121',
      borderColor: isDarkMode ? '#ffffff' : '#000000',
      borderWidth: 1,
    };
  }
  return {
    color: DOT_COLOR_BY_KEY[key] || COURSE_TYPE_DEFAULT_DOT,
  };
}

export function courseTypeToDotSlug(courseTypeRaw) {
  const canonical = canonicalCourseType(courseTypeRaw);
  if (!canonical) return 'default';
  return collapseCourseTypeSpaces(canonical).toLowerCase().replace(/\s+/g, '-');
}

export function sortCourseTypesForCalendar(types) {
  const seen = new Set();
  const unique = [];
  (Array.isArray(types) ? types : []).forEach((raw) => {
    const canonical = canonicalCourseType(raw);
    if (!canonical) return;
    const key = canonical.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(canonical);
  });
  return unique.sort((a, b) => {
    const ia = TYPE_SORT_INDEX[a.toLowerCase()] ?? 999;
    const ib = TYPE_SORT_INDEX[b.toLowerCase()] ?? 999;
    if (ia !== ib) return ia - ib;
    return a.localeCompare(b, undefined, { sensitivity: 'base' });
  });
}
